module.exports = __webpack_public_path__ + "src/assets/individualImages/melliferaPartyHat.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/individualImages/melliferaPartyHat.png
// module id = ./src/assets/individualImages/melliferaPartyHat.png
// module chunks = 0